/* MODERN 50 mm - 33 decors running on the same 50 mm price grids.
   Three families, because the maximum width differs per decor (3000 / 3600 /
   2700 mm), and two price groups, because 12 decors carry the 35% surcharge
   (group 5 = MODERN x1.35, derived inside naru-wood-50b.js).
   The two axes are INDEPENDENT: 48, 66 and 67 are surcharged but still run to
   3000 mm, so they sit in the 3000 family carrying g:5. The family decides how
   wide the blind may be; the group decides what it costs.
   Minimum width is 450 mm - the C+T price list starts there; 400 mm exists
   only on the Retro system, which is not sold.
   Loads after naru-wood-50b.js. */
(function(){
var W=window.NARU_W50;
if(!W||!W.CT){return;}

function S(list,g){return list.map(function(c){return {c:c,g:g};});}
var base={mat:'wood',sw:50,grps:[0,1,2,3,5],groups:0,w0:0.5,h0:0.3,stack:[55,65]};
function fam(id,lim){var f={id:id,lim:lim};for(var k in base){f[k]=base[k];}return f;}

window.NARU_W50M={
  CT:W.CT,
  GRP:W.GRP,
  SLATS:S(['21MM','24MM','25MM','32MM','37MM','39MM','46MM','47MM','49MM','53MM','54MM','56MM','59MM','60MM','65MM'],1).concat(S(['48MM','66MM','67MM'],5)),
  FAM:fam('w50m',[450,3000,300,4000])
};

window.NARU_W50MW={
  CT:W.CT,
  GRP:W.GRP,
  SLATS:S(['20MM','26MM','27MM','38MM','55MM','58MM'],1),
  FAM:fam('w50mw',[450,3600,300,4000])
};

window.NARU_W50MS={
  CT:W.CT,
  GRP:W.GRP,
  SLATS:S(['35MM','36MM','50MM','51MM','52MM','57MM','87MM','88MM','89MM'],5),
  FAM:fam('w50ms',[450,2700,300,4000])
};
})();
